import React, { FC, ReactElement } from 'react';
import { formatNumber } from 'humanize-plus';
import { titleize } from 'inflection';

import { StyleProps } from '@buyside/components/presentation/IdeaShowPage/InfoTable/infoTable';

import { chunk } from '@buyside/util/arrayHelper';

import { Maybe, UserCreditData } from '@interfaces/graphql-typings';

import styles from '@buyside/components/presentation/IdeaShowPage/RightSidebar/PositionInformation/positionInformationStyles.scss';

const SecurityData: FC<StyleProps & {
  userCreditData: Maybe<
    Pick<
      UserCreditData,
      | 'couponFrequency'
      | 'couponRate'
      | 'couponType'
      | 'fitchCreditRating'
      | 'moodyCreditRating'
      | 'standardCreditRating'
    >
  >;
}> = ({ dataStyle, labelStyle, userCreditData }) => {
  const {
    couponFrequency,
    couponRate,
    couponType,
    fitchCreditRating,
    moodyCreditRating,
    standardCreditRating
  } = userCreditData || {};
  const noCouponType = !couponType || couponType === 'n/a';

  const securityItems = [
    noCouponType
      ? null
      : {
          label: 'COUPON RATE',
          data: couponRate ? `${formatNumber(couponRate, 2)}%*` : 'N/A'
        },
    { label: 'COUPON TYPE', data: couponType ? `${couponType}*` : 'N/A' },
    noCouponType
      ? null
      : {
          label: 'COUPON FREQUENCY',
          data: couponFrequency ? `${titleize(couponFrequency)}*` : 'N/A'
        },
    {
      label: 'STANDARD CREDIT RATING',
      data: standardCreditRating ? `${standardCreditRating}*` : 'N/A'
    },
    {
      label: 'MOODY CREDIT RATING',
      data: moodyCreditRating ? `${moodyCreditRating}*` : 'N/A'
    },
    {
      label: 'FITCH CREDIT RATING',
      data: fitchCreditRating ? `${fitchCreditRating}*` : 'N/A'
    }
  ].filter((el): boolean => Boolean(el)) as { label: string; data: string }[];

  return (
    <table className={styles.table}>
      <tbody>
        {chunk(securityItems, 2).map(
          ([first, second], idx): ReactElement => (
            <tr key={idx}>
              <td>
                <div className={labelStyle}>{first.label}</div>
                <div className={dataStyle}>{first.data}</div>
              </td>
              {second && (
                <td>
                  <div className={labelStyle}>{second.label}</div>
                  <div className={dataStyle}>{second.data}</div>
                </td>
              )}
            </tr>
          )
        )}
      </tbody>
    </table>
  );
};

export default SecurityData;
